import { APICallV2Post } from '../APICall';

export class UnPublishFileApiCall extends APICallV2Post {
    _method = 'file/unpublish';
}
